





































































































































































import {
  Vue,
  Prop,
  Emit,
  Watch,
} from 'vue-property-decorator';
import { Mixins, Component } from 'vue-mixin-decorator';
import moment from 'moment';
import AuthConnector from '@/connector/Auth.vue';
import DialogConnector from '@/connector/Dialog.vue';
import TransactionMixin from '@/mixins/transactionMixin';

@Component({
  components: {
    AuthConnector,
    DialogConnector,
  },
})
export default class TransactionDialog extends Mixins<TransactionMixin>(TransactionMixin) {
  @Prop({ type: Boolean, required: true }) open: boolean|undefined;

  public trasactionType: number = 0;

  public transactions: any = {};

  get dialog() {
    return this.open;
  }

  set dialog(value) {
    this.close();
  }

  @Emit('close-dialog')
  // eslint-disable-next-line class-methods-use-this
  close() {
    return false;
  }

  @Watch('trasactionType', { immediate: true })
  async onTransactionTypeChange(value: number) {
    let type = 'deposit';
    if (value === 1) type = 'withdraw';
    if (value === 2) type = 'promotions';
    this.transactions = await this.fetchTransaction(type);
  }

  getTransactionTypeText(): string {
    if (this.trasactionType === 1) return 'ถอนเงิน';
    return 'ฝากเงิน';
  }

  // eslint-disable-next-line class-methods-use-this
  getTransactionStatusText(status: string): string {
    if (status === 'APPROVED') return 'สำเร็จ';
    if (status === 'REJECTED') return 'ไม่สำเร็จ';
    return 'กำลังดำเนินการ';
  }

  // eslint-disable-next-line class-methods-use-this
  getTransactionStatusColor(status: string): string {
    if (status === 'APPROVED') return 'green';
    if (status === 'REJECTED') return 'red';
    return 'amber';
  }

  // eslint-disable-next-line class-methods-use-this
  getHumanTime(time: number) {
    return moment(time).format('YYYY-MM-DD HH:mm:ss');
  }
}
